// @ts-nocheck
import { object, string } from 'yup'
import { t } from 'ttag'

import { PASSWORD_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [PASSWORD_FIELD]: string()
      .required(t`This field cannot be empty.`)
      .min(8, t`Password must contain at least 8 characters.`),
  })